export var forceReflow = function forceReflow(node) {
  return node.scrollTop;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-transition-group/esm/utils/reflow.js
// module id = 897
// module chunks = 31